//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <DIV class='content-wrapper'
   v-loading="loadingSpinner"
   element-loading-text="Подождите">

  <div style="width:100%; float:left">
    <div style="float:left">
      <p style="font-size:16px; padding-top:0px;">Карточки продуктов интернет-магазина</p>
    </div>
    <div style="margin-top:-5px; padding-left:5px; float:left">
      <Button type="text" size="small" style="border-radius:3px; margin-bottom:5px; padding-top:5px;" @click="reloadOnClick">
        <Icon type="ios-loop" size="18"></Icon>
      </Button>
    </div>
  </div>

  <div v-if="commonData.isLoaded == false">
    Подождите, загружаются общие данные
  </div>
  <div v-else-if="dataIsLoaded == false">
    Подождите, загружаются данные по банкам
  </div>
  <div v-else style="width:100%; float:left">

   <!--div :style="expandTable == 2 ? 'width:100%' : expandTable == 1 ? 'width:calc(100% - 715px)' : 'width:0px'" style="height:100%; padding-right:0px; float:left;" :class="(expandTable == 0) ? 'hidden' : ''"-->
   <div :style="expandTable == 2 ? 'width:calc(100% - 715px)' : expandTable == 1 ? 'width:calc(100% - 715px)' : 'width:0px'" style="height:100%; padding-right:0px; float:left;" :class="(expandTable == 0) ? 'hidden' : ''">

    <div style="width:50px; padding-top:11px; padding-bottom:0px; display:inline-block; float:left;"><span>Фильтр</span></div>
    <div style="padding:5px 7px 5px 0; display:inline-block; width:calc(100% - 0px); max-width:300px">
      <Input v-model="filterValue" size="large" style="width:100%" v-on:on-change="numOfItemsToShowWithEmptyFilter=numOfItemsToShowWithEmptyFilterByDefault;filterValueOnChange()"/>
    </div>

    <div style="margin:0 10px 0 0px; display:inline-block;">
      <Button type="ghost" style="border-radius:3px; height:36px; margin-bottom:0px;" size="large" :disabled="(editingDataRow != null) && (editingDataRow.val.id == null)" @click="newEditingDataRowOnClick">+</Button>
    </div>

    <div v-if="filteredRecords.length > 0" style="padding-top:10px">
     <div v-for="(itemData, keyData) in filteredRecords" :key="keyData" style="width:calc(100% - 7px); max-width:200px; max-height:235px; padding:5px; margin:0 10px 10px 0; border-radius:10px; float:left;"
      :style="{border: isRowSelected(itemData) == true ? '2px solid #a0a7ff' : '2px solid #aaa',
              color: isRowSelected(itemData) == true ? '#fff' : '#fff',
              background: isRowSelected(itemData) === true ? '#a0a7ff' : '#a9acb7'}"
      @click="dataRowOnSelect(itemData)"> <!--#778087-->

      <div :style="{'background-image':'url('+appSettings.server.host+appSettings.server.fileEntityGetFile+itemData.val.body.images[0]+')'}" class="product-image-thumb">&nbsp</div>
      <div style="width:100%; min-height:25px; margin:7px 0 0px 0; padding:0px; float:left; text-align:left;">
        <span class="product-text">{{itemData.val.id}}:&nbsp;{{itemData.val.name}}&nbsp;</span>
      </div>

     </div>

     <div v-if="filteredRecords.length == numOfItemsToShowWithEmptyFilter" style="clear:left">
       <br><br>
       * Список не полный, еще много всего найдено. Используйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.<br><br>
       <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" @click="addItemsToShowInLazyShowingList">Показать еще</Button>
       <br><br><br><br>
     </div>
    </div>

    <div v-else>
      * Ничего не найдено. Скорректируйте фильтр, чтобы увидеть необходимые данные. Минимум 3 символа.
    </div>

   </div>

   <DIV :style="expandTable == 0 ? 'width:100%' : expandTable == 1 ? 'width:710px;' : 'width:710px'" style="padding: 0px 0px 10px 20px; border-left:1px solid #ccc; position:fixed; top:100px; left:calc(100vw - 745px);float:left;">
   <!--DIV :style="expandTable == 0 ? 'width:100%' : expandTable == 1 ? 'width:710px;' : 'width:0px'" style="padding: 0px 0px 10px 20px; border-left:1px solid #ccc; position:fixed; top:100px; left:calc(100vw - 745px);float:left;" :class="(expandTable == 2) ? 'hidden' : ''"-->
   <!--DIV :style="expandTable == 0 ? 'width:100%' : expandTable == 1 ? 'width:710px;' : 'width:0px'" style="padding: 0px 0px 10px 20px; border-left:1px solid #ccc; float:left;" :class="(expandTable == 2) ? 'hidden' : ''"-->
   <div style="width:710px; padding:0px; float:left;">

     <div v-if="editingDataRow != null">

        <div style="width:100%; float:left">
          <!--Button type="text" class="top-panel-toggle-table-button" @click="toggleCollapseTableOnClick">
            <Icon :type="expandTable == 0 ? 'chevron-right' : 'chevron-left'"></Icon>
          </Button-->
          <br><br><br><br>
        </div>

        <div style="width:100%; padding-top:5px; padding-bottom:20px; display:inline-block; float:left;">
          <span v-if="editingDataRow.val.id != null"><b>РЕДАКТИРОВАНИЕ :</b></span>
          <span v-else><b>НОВАЯ КАРТОЧКА ПРОДУКТА :</b></span>
        </div>

        <div id="editingdatarowimage1" :style="{'background-image':'url('+appSettings.server.host+appSettings.server.fileEntityGetFile+editingDataRow.val.body.images[0]+')'}" class="editingdatarow-image">&nbsp</div>
        <div id="editingdatarowimage2" :style="{'background-image':'url('+appSettings.server.host+appSettings.server.fileEntityGetFile+editingDataRow.val.body.images[1]+')'}" class="editingdatarow-image">&nbsp</div>
        <div id="editingdatarowimage3" :style="{'background-image':'url('+appSettings.server.host+appSettings.server.fileEntityGetFile+editingDataRow.val.body.images[2]+')'}" class="editingdatarow-image">&nbsp</div>
        <div id="editingdatarowimage4" :style="{'background-image':'url('+appSettings.server.host+appSettings.server.fileEntityGetFile+editingDataRow.val.body.images[3]+')'}" class="editingdatarow-image">&nbsp</div>
        <div id="editingdatarowimage5" :style="{'background-image':'url('+appSettings.server.host+appSettings.server.fileEntityGetFile+editingDataRow.val.body.images[4]+')'}" class="editingdatarow-image">&nbsp</div>
        <div id="editingdatarowimage6" :style="{'background-image':'url('+appSettings.server.host+appSettings.server.fileEntityGetFile+editingDataRow.val.body.images[5]+')'}" class="editingdatarow-image">&nbsp</div>
        <div style="width:115px; padding:0px 0 5px 0; text-align:center; float:left;">
          <input type="file" ref="editingDataRowFileRef1" @change="uploadingFileOnChange(1)" class="input_file_hidden"/>
          <button @click="$refs.editingDataRowFileRef1.click()" style="padding:0px 15px 2px 15px; font-size:10px; color:#fff; background:#aaa; border: solid 1px #a0a0a0; border-radius:3px 3px 3px 3px;"><icon class="fas fa-arrow-up"/></button>
        </div>
        <div style="width:115px; padding:0px 0 5px 0; text-align:center; float:left;">
          <input type="file" ref="editingDataRowFileRef2" @change="uploadingFileOnChange(2)" class="input_file_hidden"/>
          <button @click="$refs.editingDataRowFileRef2.click()" style="padding:0px 15px 2px 15px; font-size:10px; color:#fff; background:#aaa; border: solid 1px #a0a0a0; border-radius:3px 3px 3px 3px;"><icon class="fas fa-arrow-up"/></button>
        </div>
        <div style="width:115px; padding:0px 0 5px 0; text-align:center; float:left;">
          <input type="file" ref="editingDataRowFileRef3" @change="uploadingFileOnChange(3)" class="input_file_hidden"/>
          <button @click="$refs.editingDataRowFileRef3.click()" style="padding:0px 15px 2px 15px; font-size:10px; color:#fff; background:#aaa; border: solid 1px #a0a0a0; border-radius:3px 3px 3px 3px;"><icon class="fas fa-arrow-up"/></button>
        </div>
        <div style="width:115px; padding:0px 0 5px 0; text-align:center; float:left;">
          <input type="file" ref="editingDataRowFileRef4" @change="uploadingFileOnChange(4)" class="input_file_hidden"/>
          <button @click="$refs.editingDataRowFileRef4.click()" style="padding:0px 15px 2px 15px; font-size:10px; color:#fff; background:#aaa; border: solid 1px #a0a0a0; border-radius:3px 3px 3px 3px;"><icon class="fas fa-arrow-up"/></button>
        </div>
        <div style="width:115px; padding:0px 0 5px 0; text-align:center; float:left;">
          <input type="file" ref="editingDataRowFileRef5" @change="uploadingFileOnChange(5)" class="input_file_hidden"/>
          <button @click="$refs.editingDataRowFileRef5.click()" style="padding:0px 15px 2px 15px; font-size:10px; color:#fff; background:#aaa; border: solid 1px #a0a0a0; border-radius:3px 3px 3px 3px;"><icon class="fas fa-arrow-up"/></button>
        </div>
        <div style="width:115px; padding:0px 0 5px 0; text-align:center; float:left;">
          <input type="file" ref="editingDataRowFileRef6" @change="uploadingFileOnChange(6)" class="input_file_hidden"/>
          <button @click="$refs.editingDataRowFileRef6.click()" style="padding:0px 15px 2px 15px; font-size:10px; color:#fff; background:#aaa; border: solid 1px #a0a0a0; border-radius:3px 3px 3px 3px;"><icon class="fas fa-arrow-up"/></button>
        </div>

        <div style="width:100%; padding:5px 0 15px 0; text-align:center; clear:left;">
          <input type="file" ref="editingDataRowFilesRef" multiple @change="uploadingFilesOnChange()" class="input_file_hidden"/>
          <button @click="$refs.editingDataRowFilesRef.click()" style="padding:4px 12px 4px 12px; font-size:13px; color:#fff; background:#aaa; border: solid 1px #a0a0a0; border-radius:5px 5px 5px 5px;"><icon class="fas fa-upload"/></button>
        </div>

     </div>

   </div>

   <div style="width:330px; padding:0px; float:left;">

     <div v-if="editingDataRow != null">

        <div style="width:110px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Опубликовать</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <Checkbox v-model="editingDataRow.val.publish" size="small" style="margin:0px 0 0 0;"></Checkbox>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:10px; display:inline-block; float:left;"><span>Артикул</span></div>
        <div style="padding-top:3px; padding-bottom: 10px; display:inline-block; clear:left; width:calc(100% - 110px)">
          {{editingDataRow.val.id}}&nbsp;
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Имя</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <input v-model="editingDataRow.val.name" style="width:100%; height:28px;" class="input_style"></input>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Бренд</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <input v-model="editingDataRow.val.brand" style="width:100%; height:28px;" class="input_style"></input>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>URL</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <input v-model="editingDataRow.val.url" style="width:100%; height:28px;" class="input_style"></input>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Цена</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <input v-model="editingDataRow.val.price" style="width:100%; height:28px;" class="input_style"></input>
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Цена со скидкой</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          <input v-model="editingDataRow.val.priceSale" style="width:100%; height:28px;" class="input_style"></input>
        </div>

        <!--div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>ColorsSizes</span></div>
        <div style="padding-bottom:10px; display:inline-block; clear:left; width:calc(100% - 110px)">
          {{editingDataRow.val.colorsSizes}}&nbsp;
        </div>

        <div style="width:110px; padding-top:3px; padding-bottom:5px; display:inline-block; float:left;"><span>Body</span></div>
        <div style="padding-bottom:5px; display:inline-block; clear:left; width:calc(100% - 110px)">
          {{editingDataRow.val.body}}
        </div-->

     </div>

   </div>

   <div style="width:355px; padding:0px 0 0 20px; float:left;">

     <div v-if="editingDataRow != null">
       <el-radio-group v-model="editingDataRow.val.gender" size="mini" fill="#6c76af">
         <el-radio-button label="0">Унисекс</el-radio-button>
         <el-radio-button label="1">Мужское</el-radio-button>
         <el-radio-button label="2">Женское</el-radio-button>
       </el-radio-group>
     </div>

     <DIV v-if="editingDataRow != null">

     <div style="width:101px; margin:5px 0 0 7px; display:inline-block; font-size:13px; float:left;">Размер</div>
     <div style="width:140px; margin:5px 0 0 5px; display:inline-block; font-size:13px; float:left;">Цвет</div>
     <div style="width:70px; margin:5px 0 0 5px; display:inline-block; font-size:13px; float:left;">Артикул</div>

     <div v-if="editingDataRowColorsSizes.length > 0">
     <div v-for="(itemData, keyData) in editingDataRowColorsSizes" :key="keyData" style="width:100%; height:28px; padding:5px 0 0 0; margin:0 10px 5px 0; float:left;">

        <div style="width:60px; padding:0px; display:inline-block; float:left;">
          <select v-model="itemData.size" filterable style="width:60px; padding-top:3px; margin-left:3px; height:28px; background-color:#fff" @change="editingDataRowColorsSizesOnChange(itemData, keyData)">
            <option v-for="(item, index) in sizes" :value="item" :key="index">{{item}}</option>
          </select>
        </div>

        <div style="width:28px; height:28px; margin:0px 0 0 10px; display:inline-block; border:solid 1px #ddd; border-radius:4px; float:left;" :style="{'background':getColorById(itemData.color)}">&nbsp;</div>
        <div style="width:145px; margin-left:0px; display:inline-block; float:left;">
          <el-select v-model="itemData.color" size="mini" :filterable="true" placeholder="выберите цвет" no-match-text="нет такого цвета"
            style="width:145px; padding:0px; margin:0px; font-size:10px" @change="editingDataRowColorsSizesOnChange(itemData, keyData)">
            <el-option v-for="(item, key) in colors" :value="key" :label="item.text" :key="key">
              <span style="width:20px; height:20px; margin:7px 10px 0 0; border:solid 1px #aaa; border-radius:4px; float:left" :style="{'background':item.col}">&nbsp</span>
              <span span="float:right">{{item.text}}</span>
            </el-option>
          </el-select>
        </div>

        <div style="width:70px; margin-left:6px; padding:0px; display:inline-block; float:left;">
          <input v-model="itemData.productRef" style="width:70px; height:28px;" class="input_style" @change="editingDataRowColorsSizesOnChange(itemData, keyData)"></input>
        </div>

        <div style="width:10px; margin:8px 0 0 5px; padding:0px; display:inline-block; clear:left;" @click="delEditingDataRowColorsSizes(keyData)">
          <icon class="fas fa-times" style="font-size:13px"></icon>
        </div>

     </div>
     </div>

     <Button type="ghost" style="border-radius:3px; height:28px; margin:5px 0 0 3px; padding:0 10px 0 10px; float:left;" size="small" @click="addEditingDataRowColorsSizes">+</Button>

     </DIV>

   </div>

   <div style="width:710px; padding:0 25px 0 0; float:left;">
     <div v-if="editingDataRow != null">

        <div style="padding: 35px 0px 5px 0px;">
          <Button type="warning" style="border-radius:3px; margin-bottom:10px;" @click="saveEditingDataRowOnClick">Сохранить</Button>
          <Button type="ghost" style="border-radius:3px; margin-bottom:10px;" @click="cancelEditingDataRowOnClick">Отменить</Button>
          <!--Button type="ghost" style="float:right; border-radius:3px; margin-bottom:10px; padding-top:5px; color:#d7d7d7;" :class="editingDataRow.val.id == null ? 'hidden' : ''" @click="deleteEditingDataRowOnClick">
            <Icon type="trash-b" size="18"></Icon>
          </Button-->
        </div>

     </div>

     <div v-else>
       * Выберите запись для просмотра или редактирования
       <br><br><br>
     </div>

   </div>
   </DIV>

  </div>
  </DIV>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters, mapMutations } from 'vuex'

import async from 'async'

import http from 'axios'

import restResource from '@/technical/restResource'
import serverErrorHandling from '@/technical/serverErrorHandling'

import arrayTools from '@/technical/arrayTools/arrayTools'

// import serverData from '@/store/serverData'

export default {
  components: { },
  data () {
    return {
      data: [], // list of component records
      filteredRecords: [],

      // UI FIELDS
      dataIsLoaded: false,
      numOfItemsToShowWithEmptyFilter: 50,
      numOfItemsToShowWithEmptyFilterByDefault: 50,

      filterValue: '',

      expandTable: 2, // 0-editing only,table collpsed  1-table + editing  2-table only

      loadingSpinner: false,

      selectedDataRow: null,
      editingDataRow: null,
      editingDataRowFiles: {1: '', 2: '', 3: '', 4: '', 5: '', 6: ''}, // это не файлы которые пришли с записью из БД, это файлы загруженные пользователем в браузере на замену
      editingDataRowColorsSizes: [],
      sizes: ['OS', 'Ж38', 'Ж40', 'Ж42', 'Ж44', 'Ж46', 'Ж48', 'Ж50', 'Ж52', 'Ж54', 'Ж56', 'Ж58', 'М40', 'М42', 'М44', 'М46', 'М48', 'М50', 'М52', 'М54', 'М56', 'М58', 'М60'],
      colors: {
        '00': {col: '#000', text: 'черный'},
        '01': {col: '#aaa', text: 'серый'},
        '02': {col: '#fff', text: 'белый'},
        '03': {col: '#da4433', text: 'красный'},
        '04': {col: '#fcb', text: 'роз-беж'},
        '05': {col: '#ff8', text: 'желтый'},
        '06': {col: '#92b14c', text: 'зеленый'},
        '07': {col: '#7093e8', text: 'синий'},
        '08': {col: '#986ff7', text: 'фиолетовый'},
        '09': {col: '#923a24', text: 'коричневый'},
        '10': {col: '#ff9900', text: 'оранжевый'},
        '99': {col: '#c86dd2', text: 'другое'}
      }
    }
  },
  computed: {
    ...mapGetters([
      'appSettings',
      'activeUser',
      'commonData'
    ])
  },
  created: function () {
    // var thisRef = this
    // this.data = serverData.finixBanks // если перезаугрузка данной страницы то тут ничего еще не загружено и пусто. получаем через event FinixBanksChanged
    // thisRef.dataIsLoaded = true // !!! т к это CommonData то когда commonData.isLoaded == true то сразу ставим и dataIsLoaded = true

    /* serverData.finixBanksOnDestroyDelegates.push(this.deleteDataRecDelegate)

    serverData.eventsBus.$on('finixBanksChanged', (data) => {
      // console.log('on finixBanksChanged')
      // console.log(data)
      // if (this.editingDataRec.val.id === data.record.id) {
      //  this.editingDataRec.val = Object.assign({}, data.record)
      // }
      if (data.method === 'read') thisRef.dataIsLoaded = true
      thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
    })

    // если это не перезагрузка данной страницы то serverData уже давно бы был и тут бы мы строили список наших отображаемых данных
    // но это только для CommonData, т е тех что загружаются в приложени по умолчанию. а наши данные надо тут указать что грузим
    thisRef.filterValueOnChange() // чтобы отобразить список после создания компонента
    // serverData.finixBanksReload(function () {}) // вместо callback функционал сработает через serverData.eventsBus.$on('finixBanksChanged')
    */
    this.reloadOnClick()
  },
  methods: {
    ...mapMutations([
      'commonDataIsLoadedSet'
    ]),
    uploadingFilesOnChange () {
      for (var i = 0; i < this.$refs.editingDataRowFilesRef.files.length; i++) {
        this.uploadingFileOnChange(i + 1, this.$refs.editingDataRowFilesRef.files[i])
      }
    },

    uploadingFileOnChange (fileIndx, file) {
      // забираем себе объект готового к загрузке файла
      if (file != null) this.editingDataRowFiles[fileIndx] = file
      else this.editingDataRowFiles[fileIndx] = this.$refs['editingDataRowFileRef' + fileIndx].files[0]

      if (this.editingDataRowFiles[fileIndx]) {
        // меняем картинку редактируемого fileEntity
        var reader = new FileReader()
        reader.onload = function (e) {
          var el = document.getElementById('editingdatarowimage' + fileIndx)
          el.style.backgroundImage = 'url(' + e.target.result + ')'
        }
        reader.readAsDataURL(this.editingDataRowFiles[fileIndx])
      }
    },

    reloadOnClick () {
      var thisRef = this
      // thisRef.data = [] // трется внутри serverData.reload
      thisRef.dataIsLoaded = false

      // serverData.finixBanksReload(function (err) {
        // if (err) return serverErrorHandling(err, thisRef)
        // вместо этих строк работает serverData.eventsBus.$on('finixBanksChanged', (data))
        // thisRef.data = serverData.finixBanks // data так и смотрела на serverData которые не перезаписывались а стирались и добавлялись
        // thisRef.filterValueOnChange()
      // })

      // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! это надо выносить в общий компонент читки статических данных с сервера и занесение их в store.CommonData
      var cmsIShopProducts = []
      http.get(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsIShopProductResource)
      .then(function (response) {
        if (response.data == null) return serverErrorHandling('что-то не так', thisRef)
        // users[0] = {Name: '- Выберите автора -', id: 0}
        for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
          var oneCMSIShopProductResource = restResource(thisRef.appSettings.server.host + thisRef.appSettings.server.cmsIShopProductResource)
          oneCMSIShopProductResource.val = response.data[itemIndx]
          cmsIShopProducts.push(oneCMSIShopProductResource)
        }
        thisRef.data = cmsIShopProducts
        thisRef.numOfItemsToShowWithEmptyFilter = thisRef.numOfItemsToShowWithEmptyFilterByDefault
        thisRef.filterValueOnChange()
        thisRef.dataIsLoaded = true
        thisRef.selectedDataRow = null
        thisRef.editingDataRow = null
        thisRef.editingDataRowFiles = {1: '', 2: '', 3: '', 4: '', 5: '', 6: ''}
        thisRef.editingDataRowColorsSizes = []
      })
      .catch((error) => serverErrorHandling(error, thisRef))
    },

    filterValueOnChange () {
      this.filteredRecords.splice(0, this.filteredRecords.length)

      if (this.data.length === 0) return

      for (let i = this.data.length - 1; i >= 0; i--) {
        if (this.filterValue.length < 3) {
          if (this.filteredRecords.length < this.numOfItemsToShowWithEmptyFilter) this.filteredRecords.push(this.data[i])
          continue
        }

        if (this.data[i].val.id.toString().indexOf(this.filterValue) !== -1) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        var filterValueLowerCase = this.filterValue.toLowerCase()
        if ((this.data[i].val.name != null) && (this.data[i].val.name.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
        if ((this.data[i].val.extension != null) && (this.data[i].val.extension.toLowerCase().indexOf(filterValueLowerCase) !== -1)) {
          this.filteredRecords.push(this.data[i])
          continue
        }
      }

      arrayTools.sort(this.filteredRecords, function (a, b) {
        return a.val.id < b.val.id
      })
    },

    newEditingDataRowOnClick () {
      var newEntity = restResource(this.appSettings.server.host + this.appSettings.server.cmsIShopProductResource)
      newEntity.val = {}
      newEntity.val.name = ''
      newEntity.val.brand = ''
      newEntity.val.url = ''
      newEntity.val.price = 0
      newEntity.val.priceSale = ''
      newEntity.val.gender = 0
      newEntity.val.colorsSizes = ''
      newEntity.val.publish = true
      newEntity.val.body = {
        images: [0, 0, 0, 0, 0, 0],
        profuctsRefs: {}
      }

      this.selectedDataRow = null
      this.editingDataRow = Object.assign({}, newEntity)
      this.editingDataRow.val = Object.assign({}, newEntity.val)
      this.editingDataRow.val.body = Object.assign({}, newEntity.val.body)
      this.editingDataRowFiles = {1: '', 2: '', 3: '', 4: '', 5: '', 6: ''}
      this.editingDataRowColorsSizes = []
      this.setEditingDataRowColorsSizes()

      this.expandTable = 1 // to show newEntity editing
    },

    cancelEditingDataRowOnClick () {
      this.selectedDataRow = null
      this.editingDataRow = null
      this.editingDataRowFiles = {1: '', 2: '', 3: '', 4: '', 5: '', 6: ''}
      this.editingDataRowColorsSizes = []
      this.expandTable = 2
    },

    saveProductImage (fileIndx, cb) {
      // console.log(fileIndx)
      // console.log(this.editingDataRowFiles[fileIndx])
      if (this.editingDataRowFiles[fileIndx] === '') return cb()
      let formData = new FormData()
      if (this.editingDataRow.val.body.images[fileIndx - 1] !== 0) formData.append('id', this.editingDataRow.val.body.images[fileIndx - 1]) // если заменяем файл, то вносим fileEntity id
      var extension = this.editingDataRowFiles[fileIndx].name.substr(this.editingDataRowFiles[fileIndx].name.lastIndexOf('.') + 1)
      formData.append('name', fileIndx.toString() + '.' + extension) // имена файлов от пользователя не имеют значения. заменяем на типа '1.jpg'
      formData.append('container', 'cmsIShopProductsImages')
      formData.append('_data', this.editingDataRowFiles[fileIndx])

      http.post(this.appSettings.server.host + this.appSettings.server.fileEntityResource + '/storeFileByFormData/', formData, {headers: {'Content-Type': 'multipart/form-data'}})
      .then(function (response) {
        return cb(null, response) // здесь из data берем fileEntity и из нее id для обновления данных images в записи product
      })
      .catch() // сам вызывает asyncCallback
    },

    saveEditingDataRowOnClick () {
      if (this.editingDataRow.val.name === '') return this.$message.error('Введите название')
      if (this.editingDataRow.val.price === '') return this.$message.error('Введите цену')
      if (Number(this.editingDataRow.val.price) !== Number(this.editingDataRow.val.price)) return this.$message.error('Цена должна быть числом')
      if (Number(this.editingDataRow.val.priceSale) !== Number(this.editingDataRow.val.priceSale)) return this.$message.error('Цена со скидкой должна быть числом')
      if (this.editingDataRow.val.priceSale === '') this.editingDataRow.val.priceSale = null

      var thisRef = this

      thisRef.loadingSpinner = true
      const loading = thisRef.$loading({
        lock: true,
        text: 'Подождите, идет сохранение данных'
      })

      async.parallel({
        file1: function (asyncCallback) {
          thisRef.saveProductImage(1, function (err, response) {
            if ((err == null) && (response != null)) thisRef.editingDataRow.val.body.images[0] = response.data.id
            asyncCallback(err)
          })
        },
        file2: function (asyncCallback) {
          thisRef.saveProductImage(2, function (err, response) {
            if ((err == null) && (response != null)) thisRef.editingDataRow.val.body.images[1] = response.data.id
            asyncCallback(err)
          })
        },
        file3: function (asyncCallback) {
          thisRef.saveProductImage(3, function (err, response) {
            if ((err == null) && (response != null)) thisRef.editingDataRow.val.body.images[2] = response.data.id
            asyncCallback(err)
          })
        },
        file4: function (asyncCallback) {
          thisRef.saveProductImage(4, function (err, response) {
            if ((err == null) && (response != null)) thisRef.editingDataRow.val.body.images[3] = response.data.id
            asyncCallback(err)
          })
        },
        file5: function (asyncCallback) {
          thisRef.saveProductImage(5, function (err, response) {
            if ((err == null) && (response != null)) thisRef.editingDataRow.val.body.images[4] = response.data.id
            asyncCallback(err)
          })
        },
        file6: function (asyncCallback) {
          thisRef.saveProductImage(6, function (err, response) {
            if ((err == null) && (response != null)) thisRef.editingDataRow.val.body.images[5] = response.data.id
            asyncCallback(err)
          })
        }
      }, function (error) {
        if (!error) {
          thisRef.editingDataRow.save()
          .then(function () {
            thisRef.loadingSpinner = false
            loading.close()

            thisRef.selectedDataRow = null
            thisRef.editingDataRow = null
            thisRef.editingDataRowFiles = {1: '', 2: '', 3: '', 4: '', 5: '', 6: ''}
            thisRef.editingDataRowColorsSizes = []
            thisRef.expandTable = 2

            thisRef.reloadOnClick()
          })
          .catch(function (err) {
            thisRef.loadingSpinner = false
            loading.close()
            serverErrorHandling(err, thisRef)
          })
        } else {
          thisRef.loadingSpinner = false
          loading.close()
          serverErrorHandling(error, thisRef)
        }
      })
    },
    /*
    deleteEditingDataRowOnClick () {
      var thisRef = this

      thisRef.loadingSpinner = true
      const loading = thisRef.$loading({
        lock: true,
        text: 'Подождите, идет сохранение данных'
      })

      thisRef.editingDataRow.delete()
      .then(function (response) {
        thisRef.loadingSpinner = false
        loading.close()

        thisRef.selectedDataRow = null
        thisRef.editingDataRow = null
        thisRef.editingDataRowFiles = {1: '', 2: '', 3: '', 4: '', 5: '', 6: ''}
        thisRef.editingDataRowColorsSizes = []
        thisRef.expandTable = 2

        thisRef.reloadOnClick()
      })
      .catch(function (error) {
        thisRef.loadingSpinner = false
        loading.close()
        serverErrorHandling(error, thisRef)
      })
    },
    */
    deleteDataRecDelegate (deletedRecord, cb) {
      /* var thisRef = this
      if ((thisRef.editingDataRec != null) && (deletedRecord.id === thisRef.editingDataRec.val.id)) {
        thisRef.editingDataRec = null
      } */
      return cb()
    },

    dataRowOnSelect (value) {
      this.selectedDataRow = value
      this.editingDataRow = Object.assign({}, value)
      this.editingDataRow.val = Object.assign({}, value.val)
      this.editingDataRow.body = Object.assign({}, value.val.body)
      this.editingDataRowFiles = {1: '', 2: '', 3: '', 4: '', 5: '', 6: ''}
      this.editingDataRowColorsSizes = []
      this.setEditingDataRowColorsSizes()
      this.expandTable = 1
    },

    isRowSelected (row) {
      if (this.selectedDataRow == null) return false
      if (row.val.id === this.selectedDataRow.val.id) return true
      else return false
    },

    setEditingDataRowColorsSizes () {
      this.editingDataRowColorsSizes.splice(0, this.editingDataRowColorsSizes.length)
      var items = this.editingDataRow.val.colorsSizes.split(',')
      for (var i = 0; i < items.length - 1; i++) { // -1 чтобы последний split не обрабатывать - это пустота после последней запятой в конце
        var parts = items[i].split('-')
        var one = {
          color: parts[0],
          size: parts[1],
          productRef: this.editingDataRow.val.body.productsRefs[items[i]] != null ? this.editingDataRow.val.body.productsRefs[items[i]] : 0
        }
        this.editingDataRowColorsSizes.push(one)
      }
    },

    addEditingDataRowColorsSizes () {
      // добавляем последний пустой для простого ввода удобного UX
      this.editingDataRowColorsSizes.push({color: '00', size: 'OS', productRef: 0})
      this.editingDataRowColorsSizesOnChange()
    },

    delEditingDataRowColorsSizes (indx) {
      this.editingDataRowColorsSizes.splice(indx, 1)
      this.editingDataRowColorsSizesOnChange()
    },

    getColorById (theColId) {
      for (var colId in this.colors) {
        if (colId === theColId) return this.colors[colId].col
      }
      return '#f0f' // типа ошибка. эта строка никогда не должна вызваться
    },

    editingDataRowColorsSizesOnChange () {
      this.editingDataRow.val.colorsSizes = ''
      this.editingDataRow.val.body.productsRefs = {}
      for (var i = 0; i < this.editingDataRowColorsSizes.length; i++) {
        var colSize = this.editingDataRowColorsSizes[i].color + '-' + this.editingDataRowColorsSizes[i].size
        this.editingDataRow.val.colorsSizes += colSize + ',' // !!! даем пока сохранить повторяющиеся строки размер-цвет чтобы у пользователя было столько строчек сколько он сохранял
        if (this.editingDataRow.val.body.productsRefs[colSize] == null) { // не даем сохранять повторяющиеся строки в productRefs, т е сохранится первая из дублирущихся строк
          // this.editingDataRow.val.body.productsRefs[colSize] = parseInt(this.editingDataRowColorsSizes[i].productRef)
          this.editingDataRow.val.body.productsRefs[colSize] = this.editingDataRowColorsSizes[i].productRef // !!! убрал проверку на число, чтобы можно было через запятую сохранять несколько значений. надо сделать еще проверку на буквы и символы - хотя может это такие артикулы в системе? типа просто с буквами не будет находить наличие, но в целом это не проблема cmsx
        }
      }
    },

    addItemsToShowInLazyShowingList () {
      this.numOfItemsToShowWithEmptyFilter += this.numOfItemsToShowWithEmptyFilterByDefault
      this.filterValueOnChange()
    },

    toggleCollapseTableOnClick () {
      if (this.expandTable === 1) this.expandTable = 0
      else this.expandTable = 1
    }
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 0px 0px; /* margin: 25px 20px 50px 20px; */
  padding: 20px;
  background: #fff; height: 100%; /* если цвет отличный от стандартной серой подложики для content или убираем серые margins, то чтобы серый прикрыть надо height=100% */
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.top-panel-toggle-table-button {
  margin: 0px;
  padding-top: 8px;
  padding-left: 0px;
  font-size: 17px;
  color: #5a5a5a;
  cursor: pointer;
}
.top-panel-toggle-table-button:hover {
  color: #000;
}
.datalist{
  height: 100%;
  width: 100%;
  margin: 0px 0px 0px 0px;
  padding: 0px;
  font-family: "Roboto Light", sans-serif;
  font-size: 13px;
}
.datalist-scroll {
  overflow-y: scroll;   /* надо чтобы работал scroll для mainMenu */
  height: calc(100vh - 200px);
  /* width: 257px; /* минимум на 17 пикселей больше чем mainmenu-panel.width, ща сделал на 50 больше */
}
hr {
  /*border: none; /* Убираем границу для браузера Firefox */
  /*color: #ccc; /* Цвет линии для остальных браузеров */
  /*background-color: #ccc; /* Цвет линии для браузера Firefox и Opera */
  /*height: 1px; /* Толщина линии */
  margin: 10px 0 15px 0;
  margin: 50px;
}
.product-text {
  font-size:14px;
  margin-left:10px;
}
@media screen and (max-width: 1040px) {
.product-text {
  font-size:1.1vw;
  margin-left:0px;
}
}
.product-image-thumb {
  /*height: calc(100% - 35px);*/
  padding-top:95%;
  border-radius: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.editingdatarow-image {
  width: 115px;
  height: 115px;
  margin: 0 0 5px 0;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  float: left;
}
.input_file_hidden{
  position: absolute;
  top: -500px;
}
.input_style {
 border: solid 1px #ddd;
 border-radius: 5px 5px 5px 5px;
 padding: 0 5px 0 5px;
}
.input_style:focus {
 border: solid 1px #aad;
 outline: none;
}
.input_style:hover {
 border: solid 1px #aad;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style>
.incomesAndExpensesTextarea textarea.ivu-input {
  font-size: 12px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// IShopProducts.vue?25499ae6